import angular from 'angular';
import timesheetSubmissionReceipt from "./submission-receipt/submission-receipt";
import metrics from "./metrics/metrics";
import summaryData from "./summary-data/summary-data";
import timeEntryInput from "./time-entry-input/time-entry-input";

export default angular.module('app.pages.timesheet.components', [
  timesheetSubmissionReceipt.name,metrics.name, summaryData.name,timeEntryInput.name
]);



// WEBPACK FOOTER //
// ./client/pages/timesheet/components/components.js